import React, { useState } from "react";

import {
  faFacebook,
} from "@fortawesome/free-brands-svg-icons";
import {
  faEnvelope,
  faLocationDot,
  faPhoneVolume,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CloseOutlined } from "@ant-design/icons";
import Privacy from "./Privacy";

export const CONTACT = {
  phone: "0961090688",
  email: "baoa91430@gmail.com",
  address: "431 Thủ Khoa Huân",
  facebook: "https://www.facebook.com/share/1FceB51Yze/?mibextid=wwXIfr",
  discordEmail: "le707709@gmail.com",
};

const Footer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const handleSendToMain = (action, data) => {
    if (window.electron.sendToMain) {
      window.electron.sendToMain(action, data);
    }
  };

  const handleOpenLinkContact = (link) => {
    handleSendToMain("openExternalLink", link);
  };

  return (
    <footer className="bg-[#181927] text-white pb-5">
      <div className="container mx-auto flex flex-wrap justify-between px-10">
        <div className="flex flex-col justify-between py-6 space-y-4">
          <div className="cursor-pointer relative top-2 min-w-[140px] flex justify-start">
            <img
              src="/cyber.png"
              alt="Cyber King Logo"
              width={140}
              height={50}
              className="object-contain"
            />
          </div>
        </div>

        <div className="flex flex-col py-6 space-y-2">
          <h3 className="font-bold text-[22px] pb-2">Thông tin liên hệ</h3>
          <p className="flex items-center space-x-2">
            <FontAwesomeIcon icon={faPhoneVolume} width={15} />
            <span className="text-base font-semibold">
              SĐT: {CONTACT.phone}
            </span>
          </p>
          <p className="flex items-center space-x-2">
            <FontAwesomeIcon icon={faEnvelope} width={15} />
            <span className="text-base font-semibold">
              Email: {CONTACT.email}
            </span>
          </p>
          <p className="flex items-center space-x-2">
            <FontAwesomeIcon icon={faEnvelope} width={15} />
            <span className="text-base font-semibold">
              Discord / hỗ trợ: {CONTACT.discordEmail}
            </span>
          </p>
          <p className="flex items-center space-x-2">
            <FontAwesomeIcon icon={faFacebook} width={15} />
            <span className="text-base font-semibold">
              Fanpage: {CONTACT.facebook}
            </span>
          </p>
          <p className="flex items-center space-x-2">
            <FontAwesomeIcon icon={faLocationDot} width={15} />
            <span className="text-base font-semibold">
              Địa chỉ quán: {CONTACT.address}
            </span>
          </p>
        </div>

        <div className="flex flex-col py-6 space-y-2">
          <h3 className="font-bold text-[22px] pb-2">Cộng đồng</h3>
          <div
            onClick={() => {
              handleOpenLinkContact(CONTACT.facebook);
            }}
            className="flex cursor-pointer items-center space-x-2 text-[#D1D1D4] hover:text-white"
          >
            <FontAwesomeIcon icon={faFacebook} width={20} />
            <span className="text-base font-semibold">Facebook</span>
          </div>
        </div>
      </div>
      <hr className="border-t border-gray-600" />
      <div className="text-center font-medium py-4 text-[#9BA0A0] text-base">
        Copyright © {new Date().getFullYear()} Cyberking Teemo. All rights reserved.
      </div>

      {isModalOpen && (
        <div
          className={`absolute bg-black bg-opacity-50 z-100 w-full h-full top-0 left-0 flex justify-center items-center`}
        >
          <div className="w-[80%] h-[80%] p-5 bg-white mt-24 rounded-lg relative">
            <button
              className=" absolute top-0 right-2 font-bold text-2xl text-black opacity-70 hover:opacity-100"
              onClick={handleClose}
            >
              <CloseOutlined />
            </button>
            <Privacy />
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
